import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LANGUAGES } from '../constants/lang';
import { UserService } from './user.service';
import { DateAdapter } from '@angular/material/core';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  readonly allowLanguages = Object.keys(LANGUAGES).filter((item) => {
    return isNaN(Number(item));
  });

  constructor(
    private translate: TranslateService,
    private userService: UserService,
    private dateAdapter: DateAdapter<any>
  ) {}

  init(flag: string) {
    // COMMENTATA PERCHE' IL CLIENTE NON LAVUOLE, MA DA TENERE
    // let lang = this.translate.getBrowserLang();
    // let lang = LANGUAGES.default;
    let lang = flag;
    if (lang && this.allowLanguages.includes(lang)) {
      //
    } else {
      lang = LANGUAGES.default;
    }

    this.translate.setDefaultLang(lang);
    this.dateAdapter.setLocale(lang);
    this.changeLanguage(lang);
  }

  changeLanguage(lang: LANGUAGES | string) {
    this.userService.lang = lang;
    console.log(this.userService.lang);
    this.translate.use(lang);
    this.dateAdapter.setLocale(lang);
  }
}
